import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" fillRule="evenodd" d="M27.29 11.4 17.2 1.9a2 2 0 0 0-2.4 0L4.71 11.4A2 2 0 0 0 4 12.93V28a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12.93a2 2 0 0 0-.71-1.53M6 28V12.93l10-9.41 10 9.41V28h-6v-8a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v8zm8 0h4v-8h-4z" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(IconHouseOutlineSVG);
ForwardRef.displayName = "IconHouseOutline";
export { ForwardRef as IconHouseOutline };